import React, { useEffect } from "react";
import {
    Container,
    makeStyles,
    Typography,
    Card,
    CardContent,
} from "@material-ui/core";
// function
import { headRewrite } from "../function/headRewrite";

const useStyles = makeStyles((theme) => ({
    enforcement: {
        fontWeight: "bold",
        marginTop: theme.spacing(2),
    },
    root: {
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(10, 1, 15, 1),
        },
        [theme.breakpoints.up("sm")]: {
            margin: theme.spacing(10, 2, 15, 2),
        },
        [theme.breakpoints.up("md")]: {
            margin: theme.spacing(10, 3, 15, 3),
        },
        color: "black",
        backgroundColor: "white",
    },
    regulation: {
        textAlign: "center",
        fontWeight: "bold",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    subtitle: {
        textAlign: "right",
    },
    title: {
        fontWeight: "bold",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    body: {
        whiteSpace: "pre-line",
        lineHeight: 1.9,
    },
}));

const policies = [
    {
        title: "1．レンタル注文確定後のキャンセル",
        body: `当サービスでは、注文および決済の完了と同時に、対象商品の在庫確保、貸出期間の確保および発送準備を開始します。また、決済時には所定の決済処理費用が発生するため、注文確定後のお客様都合によるキャンセル、注文内容の変更および返金はお受けしておりません。

ご注文の際は、商品、サイズ、レンタル期間、料金、配送先その他の注文内容を十分にご確認ください。

以下の事情は、お客様都合によるキャンセルに該当します。

・サイズや着用感が想定と異なる場合
・色味やデザインの印象が掲載画像と異なる場合
・着用予定やイベントが変更または中止になった場合
・注文する商品、数量、配送先またはレンタル期間を誤った場合
・商品を受け取れなかった場合
・中古品またはアーカイブ商品として通常想定される使用感、経年変化、軽微な傷、汚れ、補修跡等がある場合

商品の発送前である場合を含め、注文確定後のお客様都合によるキャンセルはお受けできません。`,
    },
    {
        title: "2．商品に問題があった場合",
        body: `次のいずれかに該当する場合は、商品の到着後24時間以内に、該当箇所が確認できる写真を添えてEnclopediaまでご連絡ください。

・注文した商品と異なる商品が届いた場合
・商品ページに記載のない重大な破損または汚損がある場合
・通常の方法では着用できない不具合がある場合
・配送中の事故によって商品が破損していた場合
・その他、商品が注文内容に適合していないとEnclopediaが確認した場合

商品の状態を確認したうえで、代替商品の提供、レンタル期間の変更、レンタル料金の全部または一部の返金、もしくは注文のキャンセルのうち、状況に応じた方法で対応します。

この場合の返送料はEnclopediaが負担します。事前の連絡なく商品を返送された場合は、返品または返金をお受けできないことがあります。

なお、商品ページにあらかじめ記載された傷、汚れ、使用感、補修跡、経年変化、個体差およびアーカイブ商品特有の仕様は、商品の不具合には該当しません。`,
    },
    {
        title: "3．レンタル商品の返却",
        body: `レンタル期間終了に伴う商品の返送は、「返品」ではなく、レンタル契約に基づく通常の「返却」として取り扱います。

お客様は、当サービスが定める返却期限および返却方法に従って商品を返却してください。返却期限を過ぎた場合、または商品が返却されない場合の取り扱いについては、利用規約および返却に関する案内をご確認ください。`,
    },
    {
        title: "4．レンタル中に購入した商品のキャンセル・返品",
        body: `レンタル中の商品を購入された場合、お客様は購入前に商品を実際に確認し、試着または着用できる状態にあるため、購入手続および決済の完了後は、お客様都合によるキャンセル、返品、交換および返金をお受けしておりません。

購入後に返却手続を行った場合であっても、購入契約は取り消されません。誤って返送した場合は、再配送に必要な送料その他の費用をお客様にご負担いただくことがあります。

ただし、購入手続の時点では合理的に確認できず、かつ商品ページに記載されていない重大な不具合が判明した場合は、この限りではありません。該当する場合は、不具合の判明後速やかに、写真を添えてEnclopediaまでご連絡ください。`,
    },
    {
        title: "5．返金方法",
        body: `Enclopediaが返金対象であると判断した場合、原則として、ご注文時に使用された決済方法を通じて返金します。

クレジットカード会社その他の決済事業者における処理状況によっては、返金が利用明細に反映されるまで一定期間を要する場合があります。`,
    },
];

export default function CancellationReturnRefundPolicy() {
    const classes = useStyles();

    const title =
        "キャンセル・返品・返金ポリシー｜Enclopedia【公式サイト】";
    const description =
        "ファッションレンタルサービスEnclopedia（アンクロペディア）のキャンセル、返品、返金に関するポリシーです。";

    useEffect(() => {
        headRewrite(title, description);
    }, []);

    return (
        <Container maxWidth="md" style={{ padding: "initial" }}>
            <Card className={classes.root}>
                <CardContent>
                    <Typography
                        variant="subtitle1"
                        component="div"
                        className={classes.subtitle}
                    >
                        Enclopedia運営
                    </Typography>

                    <Typography
                        variant="h1"
                        component="h1"
                        className={classes.regulation}
                    >
                        キャンセル・返品・返金ポリシー
                    </Typography>

                    {policies.map((policy) => (
                        <React.Fragment key={policy.title}>
                            <Typography
                                variant="subtitle1"
                                component="p"
                                className={classes.title}
                            >
                                {policy.title}
                            </Typography>

                            <Typography
                                variant="subtitle1"
                                component="p"
                                className={classes.body}
                            >
                                {policy.body}
                            </Typography>
                        </React.Fragment>
                    ))}

                    <Typography
                        variant="subtitle1"
                        component="p"
                        className={classes.enforcement}
                    >
                        2026年7月20日施行
                    </Typography>
                </CardContent>
            </Card>
        </Container>
    );
}